import React from 'react';
import { useStyletron } from 'baseui';
import { Textarea } from 'baseui/textarea';
import { CustomJsonEditor, Select } from 'commons-ui';
import { DATA_TYPES, BOOLEAN_OPTIONS } from './helper';

interface EditorProps {
	keyValue: any;
	handleChangeText: any;
	pickerValue: any;
	hasEditPermission: any;
}

const Editor: React.FC<EditorProps> = ({ keyValue, handleChangeText, pickerValue, hasEditPermission }) => {
	const [css] = useStyletron();

	if (pickerValue.length > 0) {
		if (pickerValue[0].keyType === DATA_TYPES.JSON) {
			return <CustomJsonEditor handleChangeText={handleChangeText} json={keyValue || ''} />;
		}
		if (pickerValue[0].keyType === DATA_TYPES.BOOLEAN) {
			return <Select options={BOOLEAN_OPTIONS} value={keyValue} onChange={handleChangeText} />;
		}
	}

	return (
		<div className={css({ margin: '10px 0' })}>
			<Textarea
				value={keyValue}
				onChange={(e) => handleChangeText(e.currentTarget.value)}
				placeholder='Enter Value for key here'
				overrides={{
					Input: {
						style: {
							maxHeight: '500px',
							minHeight: '200px',
							minWidth: '300px',
							width: '100vw', // fill all available space up to parent max-width
							resize: 'both'
						}
					},
					InputContainer: {
						style: {
							maxWidth: '100%',
							width: 'min-content'
						}
					}
				}}
				disabled={(pickerValue.length > 0 && pickerValue[0].keyType === DATA_TYPES.NULL) || !hasEditPermission}
			/>
		</div>
	);
};

export default Editor;
